import React from 'react';
import './contacts.css'
import { clockIcon, geoIcon, mailIcon, phoneIcon, rIcon } from '../../static/svgs';

const Contacts = () => {
    return (
        <div>
            <div className='top_contacts_container'>
                <div className='manrope-bold color_white' >Контакты</div>
                <div className='ricon_contacts_cntr1'>
                    {rIcon}
                </div>
            </div>
            <div style={styles.container} className='body_contacts_cntr'>

                <div className='body_contacts_subcntr'>
                    <div className='contacts_row'>
                        {phoneIcon}
                        <div className='manrope-bold'>{'+7 (800) 101-74-34'}</div>
                    </div>
                    <div className='contacts_row'>
                        {mailIcon}
                        <div className='manrope-bold'>{'info@registratorspb.ru'}</div>
                    </div>
                    <div className='contacts_row'>
                        {geoIcon}
                        <div className='manrope-bold'>{'г. Санкт петербург, ул. Новгородская, 23'}</div>
                    </div>
                    <div className='contacts_row'>
                        {clockIcon}
                        <div className='manrope-bold'>{'с 9:00 до 18:00 без перерыва'}</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const styles = {
    container: {
        // padding: '0px 20px',
        // backgroundColor: '#F0F3FF',
    },
    title: {
        fontFamily: 'Lobster-Regular',
        color: 'rgba(0, 114, 188, 0.8)',
        fontSize: '18px',
        textAlign: 'center',
        marginBottom: '30px',
    },
    heading: {
        fontSize: '18px',
        fontWeight: 'bold',
        marginBottom: '5px',
        color: '#333',
    },
    text: {
        fontSize: '16px',
        marginBottom: '3px',
        color: '#666',
    },
};

export default Contacts;
